import React from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";

import useStyles from "./useStyles";

const SaveButton = (props) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <Button type="submit" variant="contained" color="secondary" className={classes.button}>
      {children}
    </Button>
  );
};

SaveButton.propTypes = {
  children: PropTypes.node,
};

export default SaveButton;
